import { render, staticRenderFns } from "./disChart.vue?vue&type=template&id=35b27a7a&scoped=true"
import script from "./disChart.vue?vue&type=script&lang=js"
export * from "./disChart.vue?vue&type=script&lang=js"
import style0 from "./disChart.vue?vue&type=style&index=0&id=35b27a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b27a7a",
  null
  
)

export default component.exports